<template>
	<el-select v-model="Value" placeholder="请选择" value-key="id">
        <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :disabled="limitOption(item.name)"
        :value="item">
        </el-option>
    </el-select>
</template>
<script>
export default {
  name: 'order-sampleType-selector',
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    packageProductionType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    limitOption (name) {
      let canSelect = ['ASA', 'PCR', 'MASSARRAY']
      if (this.packageProductionType === 'PROPRIETARY') {
        if (!canSelect.includes(name)) {
          return true
        }
        return false
      }
      return false
    },
    getOptions () {
      let params = {
        example: { organizationRole: 'LAB' },
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,asc'] },
        notFormat: true
      }
      let options = []
      this.$store.dispatch('labTestPlatformList', params).then(res => {
        res.data.forEach(ele => {
        //   let obj = {
        //     label: ele.name,
        //     value: ele.name
        //   }
          options.push(ele)
        })
        this.options = options
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
